import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref } from 'vue';
import SvgIcon from '../common/SvgIcon.vue';
import { LAYOUT,UserRoles } from '../../../constants/render';
import { useBasicStore } from '../../../stores/basic';
import { useRoomStore } from '../../../stores/room';
import { storeToRefs } from 'pinia';
import TUIRoomAegis from '../../utils/aegis';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutControl',
  setup(__props) {

const basicStore = useBasicStore();
console.log("---------------basicStore-----------------------------")
const {userId, layout, userRole } = storeToRefs(basicStore);
const roomStore = useRoomStore();
const { streamNumber } = storeToRefs(roomStore);

const showLayoutList:Ref<boolean> = ref(false);
const layoutList:Ref<Node|null> = ref(null);

function handleClick(layout: any) {
  basicStore.setLayout(layout);
  TUIRoomAegis.reportEvent({ name: 'layout', ext1: layout });
}

function handleClickLayoutIcon() {
  if (!showLayoutList.value) {
    showLayoutList.value = true;
    document.addEventListener('click', handleDocumentClick, false);
  } else {
    document.removeEventListener('click', handleDocumentClick, false);
    showLayoutList.value = false;
  }
}

function handleDocumentClick(event: MouseEvent) {
  if (showLayoutList.value && layoutList.value && !layoutList.value.contains(event.target as Node)) {
    document.removeEventListener('click', handleDocumentClick);
    showLayoutList.value = false;
  }
}


return { __sfc: true,basicStore, userId, layout, userRole, roomStore, streamNumber, showLayoutList, layoutList, handleClick, handleClickLayoutIcon, handleDocumentClick, SvgIcon, LAYOUT, UserRoles }
}

})